<script setup>
import {ref, watch} from "vue"

const months = ref(["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"])
const status = ref([
    // 'draft',
    'waiting', 'approve', 'incomplete', 'paid'])
const monthNow = ref(dayjs().month() + 1)
const emits = defineEmits(['changeMonth', 'changeStatus', 'changeProjectName'])
const selectStatus = ref('waiting')
const projectName = ref(null)

watch(
    () => monthNow.value,
    (value) => {
        emits('changeMonth', value)
    }
)

watch(
    () => projectName.value,
    (value) => {
        emits('changeProjectName', value)
    }
)

watch(
    () => selectStatus.value,
    (value) => {
        emits('changeStatus', value)
    }
)
</script>


<template>
    <div class="grid grid-cols-2 gap-2 mt-4">
        <select
            v-model="monthNow"
            class="w-full rounded"
        >
            <template v-for="(month, index) in months" :key="month">
                <option
                    :value="index+1"
                >{{ month }}
                </option>
            </template>
        </select>
        <select
            v-model="selectStatus"
            class="w-full rounded"
        >
            <template v-for="item in status" :keys="item">
                <option :value="item">{{ item }}</option>
            </template>
        </select>
    </div>
    <div class="w-full mt-4">
        <div class="flex items-center">
            <div>🔍</div>
            <input class="rounded w-full ml-2" v-model="projectName" type="text" placeholder="e.g : Uber fee">
        </div>
    </div>
</template>

